// featureFlags should come from getSessionData in @confluence/session-data
export function getMediaFeatureFlags(featureFlags: { [key: string]: any }) {
	return featureFlags
		? {
				mediaInline: true,
			}
		: {};
}
